import { UseMutationOptions } from "@tanstack/react-query";
import { createConnectedAccount } from "services/api/connected-account-api.service";
import { QueryKey } from "common/enums/query-key";
import { useMutation } from "@tanstack/react-query";
import { notification } from "services/services";
import { AxiosError } from "axios";
import { BackendError } from "common/types/errors/backendError";

export default function useCreateConnectedAccount(
  options?: Omit<UseMutationOptions<string, AxiosError<BackendError>, void, unknown>, 'mutationFn'>,
) {
  return useMutation({
    mutationFn: createConnectedAccount,
    mutationKey: [QueryKey.ConnectedAccount],
    onError: (e) => {
      notification.error('Error while creating connected account');
    },
    ...options,
  });
}